import { createAction } from 'redux-actions';

export const checkIfSyncSentimentSurveyRequestedAction = createAction('CHECK_IF_SYNC_SENTIMENT_REQUESTED');
export const postSyncSentimentSurveyResultAction = createAction('POST_SYNC_SENTIMENT_RESULT');
export const postSyncSentimentSurveyResultSuccessAction = createAction('POST_SYNC_SENTIMENT_RESULT_SUCCESS');
export const postSyncSentimentSurveyResultFailureAction = createAction('POST_SYNC_SENTIMENT_RESULT_FAILURE');
